<template>
<div class="num_pad2">
    <div class="pad_btn">
        <span v-on:click="numClick('1')">1</span>
        <span v-on:click="numClick('2')">2</span>
        <span v-on:click="numClick('3')">3</span>
    </div>
    <div class="pad_btn">
        <span v-on:click="numClick('4')">4</span>
        <span v-on:click="numClick('5')">5</span>
        <span v-on:click="numClick('6')">6</span>
    </div>
    <div class="pad_btn">
        <span v-on:click="numClick('7')">7</span>
        <span v-on:click="numClick('8')">8</span>
        <span v-on:click="numClick('9')">9</span>
    </div>
    <div class="pad_btn">
        <span v-on:click="numClick('-')">-</span> 
        <span v-on:click="numClick('0')">0</span> 
        <span v-on:click="numClick('-1')"><img src="../../assets/image/delete.png"></span>
    </div>
</div>
</template>

<script>
// 사용자 정의 모듈.
const NUM_PAD = new Object();
NUM_PAD.type = {
    PHONE:{name:'PHONE', max_length: 11}, 
    PASSWORD:{name:'PASSWORD', max_length:4}, 
    AMOUNT:{name:'AMOUNT', max_length:11}, 
    NUMBER:{name:'NUMBER', max_length:0},
};

// 단위 붙이기
function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// 휴대폰 하이픈 자동입력
function autoHypenPhone(str){
  str = str.replace(/[^0-9]/g, '');
  var tmp = '';
  if( str.length < 4){
    return str;
  }else if(str.length < 7){
    tmp += str.substr(0, 3);
    tmp += '-';
    tmp += str.substr(3);
    return tmp;
  }else if(str.length < 10){
    tmp += str.substr(0, 3);
    tmp += '-';
    tmp += str.substr(3, 3);
    tmp += '-';
    tmp += str.substr(6);
    return tmp;
  }else{        
    tmp += str.substr(0, 3);
    tmp += '-';
    tmp += str.substr(3, 4);
    tmp += '-';
    tmp += str.substr(7);
    return tmp;
  }
  return str;
}

export default {
    props: {
        key_type_str:String,
        parent_key_str:String,
    },
    data: function () {
        return {
            inputKeyList: this.parent_key_str.replace(/[^0-9]/g, '').replace(/,/g,""),
        }
    },
    computed : {
        key_type: function () {
            let key_type = NUM_PAD.type.PHONE;
            switch (this.key_type_str) {
                case NUM_PAD.type.PHONE.name:
                    key_type = NUM_PAD.type.PHONE;
                    break;
                case NUM_PAD.type.PASSWORD.name:
                    key_type = NUM_PAD.type.PASSWORD;
                    break;
                case NUM_PAD.type.AMOUNT.name:
                    key_type = NUM_PAD.type.AMOUNT;
                    break;
                case NUM_PAD.type.NUMBER.name:
                    key_type = NUM_PAD.type.NUMBER;
                    break;
            }
            return key_type;
        },
    },
    methods: {
        numClick(num) {
            let numberStr = this.inputKeyList;

            // 클릭 숫자 처리.
            if(num!='-1') {
                if( (this.inputKeyList.length < this.key_type.max_length) || this.key_type.max_length==0 ) numberStr = this.inputKeyList + num;
            } else {
                // 삭제 버튼
                numberStr = this.inputKeyList.substr(0, this.inputKeyList.length-1);
            }

            // 포맷 String.
            let numberFormatStr;
            if( this.key_type===NUM_PAD.type.PHONE ) {
                // hp
                numberFormatStr = autoHypenPhone(numberStr);
            } else if( this.key_type===NUM_PAD.type.AMOUNT ) {
                // amount
                numberFormatStr = numberWithCommas(numberStr);
            } else {
                numberFormatStr = numberStr;
            }

            // 최대 길이 flag설정.
            let overMaxLength = false;
            if( this.key_type.max_length!=0 && (numberStr.length >= this.key_type.max_length) ) overMaxLength = true;

            this.$emit("numClick", numberFormatStr, overMaxLength);
        }
    },
    mounted() {
    },
    watch: {
        parent_key_str() {
            this.inputKeyList = this.parent_key_str.replace(/[^0-9]/g, '').replace(/,/g,"");
        }
    },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/components/num-pad2.vue